import i18n, { InitOptions } from 'i18next'
import { initReactI18next } from 'react-i18next'
//import Backend from 'i18next-http-backend'
import Backend from 'i18next-locize-backend';
import LanguageDetector from 'i18next-browser-languagedetector'
import rootStore from './stores/RootStore'

const i18nextOptions: InitOptions = {
  //debug: true,
  load: "all",
  supportedLngs: ["en", "es"],
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  backend: {
    //loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`
    projectId: '41a9343c-8ae0-42c1-82b6-51ae1d044993',
    version: 'latest',
  },
  detection: {
    order: ["storeDetector", "querystring", "navigator"],
    caches: ["storeDetector"]
  }
}

const lngDetector = new LanguageDetector();
  lngDetector.addDetector({
    name: "storeDetector",
    cacheUserLanguage(lng) {
      const language = lng?.split("-")[0]
      rootStore.authStore.setLanguage(language)
    },
    lookup() {
      return rootStore.authStore.language
    }
  })

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(lngDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init(i18nextOptions)

export default i18n